import React from 'react';
import {View} from 'react-native';

const RHSeparator = ({height = 0, width = 0}) => {
  return <View style={{height: height, width: width}} />;
};

export default RHSeparator;
